import {
  Lightbulb,
  Ruler,
  Boxes,
  FlaskConical,
  Factory,
  ShieldCheck,
  Package,
  Truck,
} from "lucide-react";

export const serviceIcons = {
  Lightbulb,
  Ruler,
  Boxes,
  FlaskConical,
  Factory,
  ShieldCheck,
  Package,
  Truck,
};
